import React, { useEffect, useState } from 'react'
import { Col, Dropdown, Modal, Row } from 'react-bootstrap'
import { Link, useLocation, useNavigate, matchPath, useSearchParams, } from 'react-router-dom'
import Slider from 'react-slick'
import { useAuth } from '../../context/ContextData'
import DealerConnectModal from '../../components/modals/DealerConnectModal'
import EnqulryModal from '../../components/global/EnqulryModal'

const Header = () => {
    const navigate = useNavigate();
    const { cart, setCart, wished, setWished, removeCart, removeWished,
         basicInfo, demo, setDemo, dealerId, setDealerId } = useAuth()
    const { pathname } = useLocation();
    const [searchParams] = useSearchParams();
    const url = window.location.pathname.split("/")
    const product = url[1]
    const getDealerId = searchParams.get('dealerId') || localStorage.getItem("dealerId")
    const sid = searchParams.get('sid')

    useEffect((async) => {
        if (!localStorage.getItem("dealerId") && getDealerId !== null && dealerId !== null) {
            localStorage.setItem("dealerId", getDealerId)
            setDealerId(getDealerId)
        } else if (dealerId === null) {
            setDealerId("")
        }
    }, [getDealerId, dealerId, sid, setDealerId])

    const productdetails = matchPath("/productdetails/:any/:id", pathname);
    const orderdetails = matchPath("/checkout/cart", pathname);
    const myorders = matchPath("/order", pathname);
    const about = matchPath("/about", pathname);
    const terms = matchPath("/terms", pathname);
    const privacy = matchPath("/privacy", pathname);
    const careersjobId = matchPath("/careers/:any/:any/", pathname);

    const [parms, setParms] = useState("")
    const [aboutparms, setAbout] = useState("")
    const [jobId, setJobId] = useState("")

    const [showModel , setShowModel] = useState(true);

    const [bannerData, setBanner] = useState([])

    // const [selectId, setselectId] = useState("")

    // console.log(dealerId)

    useEffect(() => {
        if (productdetails !== null) {
            setParms(productdetails.pathname)
        }
        if (orderdetails !== null) {
            setParms(orderdetails.pathname)
        }
        if (myorders !== null) {
            setParms(myorders.pathname)
        }
        if (terms !== null) {
            setParms(terms.pathname)
        }
        if (privacy !== null) {
            setParms(privacy.pathname)
        }
        if (about !== null) {
            setAbout(about.pathname)
        }
        if (careersjobId !== null) {
            setJobId(careersjobId.pathname)
        }
    }, [productdetails, orderdetails, myorders, about, terms, privacy, careersjobId]);

    const homeBanner = [
        "https://res.cloudinary.com/wallicon21/image/upload/v1642059242/react/home/headerBanner/wallpaper-home-banner_rsrxxo.jpg",
        "https://res.cloudinary.com/wallicon21/image/upload/v1642059242/react/home/headerBanner/pvc-main-banner_fhefgi.jpg",
        "https://res.cloudinary.com/wallicon21/image/upload/v1642059242/react/home/headerBanner/flooring-main-banner_hb3bqr.jpg",
        "https://res.cloudinary.com/wallicon21/image/upload/v1642059242/react/home/headerBanner/artificial-grass-main-banner_oskvqf.jpg",
        "https://res.cloudinary.com/wallicon21/image/upload/v1642059243/react/home/headerBanner/vertical-garden_main_banner_m5xeys.jpg",
        "https://res.cloudinary.com/wallicon21/image/upload/v1642059242/react/home/headerBanner/ceiling-main-banner_mgf0re.jpg",
    ]

    useEffect(() => {
        if (pathname !== '/') {
            var myHeaders = new Headers();
            myHeaders.append("wu-platform", process.env.REACT_APP_USER_SECRET);
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                product_name: product.toUpperCase().replace(/-/g, ' '),
                sid: !sid ? "" : sid,
                // dealerId: dealerId
            });

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            fetch(process.env.REACT_APP_URL + "customer/getBanner", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "success") {
                        setBanner(result.data);
                    }
                })
                .catch(error => console.log('error', error));

        }

    }, [pathname, product, sid])

    // set dealer id
    // useEffect(() => {
    //     if (dealerId && dealerId.length === 10) {
    //         var myHeaders = new Headers();
    //         myHeaders.append("wu-platform", process.env.REACT_APP_USER_SECRET);
    //         myHeaders.append("Content-Type", "application/json");

    //         var raw = JSON.stringify({
    //             "dealerId": dealerId
    //         });

    //         var requestOptions = {
    //             method: 'POST',
    //             headers: myHeaders,
    //             body: raw,
    //             redirect: 'follow'
    //         };

    //         fetch(process.env.REACT_APP_URL + "customer/dealerConnect", requestOptions)
    //             .then(response => response.json())
    //             .then(result => {
    //                 if (result.status === "success") {
    //                     localStorage.setItem("dealerId", result.data.dealerId);
    //                     localStorage.setItem("storeName", result.data.storeName);
    //                     // navigate("/");
    //                     setDealerId(result.data.dealerId);
    //                 }                })
    //             .catch(error => console.log('error', error));
    //     }
    // }, [dealerId, navigate, setDealerId]);

    // ---------------------------Cart Items------------------------

    useEffect(() => {
        const localCart = JSON.parse(localStorage.getItem("cart"))
        if (localCart && cart.length === 0) {
            if (removeCart === 0) {
                localStorage.removeItem("cart")
            } else {
                setCart(localCart)
                // setCart(prevState => ([...prevState, localCart]))
            }
        }
    }, [cart, setCart, removeCart,])

    const lDealerId = localStorage.getItem("dealerId")

    useEffect(() => {
        if (pathname === "/demo") {
            sessionStorage.setItem("demo", "demo");
            navigate("/")
        }
        if (sessionStorage.getItem("demo")) {
            setDemo("demo")
        }
        if (lDealerId) {
            sessionStorage.removeItem("demo")
            setDemo("")
        }
    }, [pathname, lDealerId, navigate, setDemo]);
    // const origin = window.location.origin

    // ---------------------------Wished Items------------------------

    useEffect(() => {
        const localWished = JSON.parse(localStorage.getItem("wished"))
        if (localWished && wished.length === 0) {
            if (removeWished === 0) {
                localStorage.removeItem("wished")
            } else {
                setWished(localWished)
            }
        }
        if (wished.length !== 0) {
            localStorage.setItem("wished", JSON.stringify(wished))
        }

    }, [wished, setWished, removeWished,])

    return (
        <React.Fragment>
            <div className="position-relative cp wm">
                {pathname === parms || pathname === aboutparms || pathname === jobId ? ''
                    : pathname === '/careers' ? <img src={"https://careers.swiggy.com/assets/img/banner3.jpg"} alt="header" className="w-100 header_bg_img" />
                        :
                        <Slider
                            className="mx-0"
                            autoplay={true}
                            speed={8000}
                            slidesToShow={1}
                            slidesToScroll={1}
                            arrows={false}
                            infinite={true}
                        >
                            {bannerData.length === 0 ?
                                homeBanner.map((item, index) =>
                                    <img key={index} src={item} alt="header" className="w-100 header_bg_img" />
                                ) :
                                bannerData.map((item, index) =>
                                    <img key={index} src={process.env.REACT_APP_S3URL + item} alt="header" className="w-100 header_bg_img" />
                                )}
                        </Slider>


                }
                {pathname !== aboutparms ? '' :
                    !basicInfo ? <div className="moreDataLoader">
                        <img src={"assets/icons/wallicon.gif"} alt="loader" />
                    </div> :
                        <div className="position-relative">
                            <img
                                src={process.env.REACT_APP_S3URL + basicInfo.storeImg}
                                alt={basicInfo.storeName}
                                className="LandingImg"
                            />
                            <div className="position-absolute aboutDealerText_16 border_Img bg-white text-center p-1">
                                {/* {!basicInfo.profileImage ?
                                    basicInfo.firstName.charAt(0).toUpperCase()
                                    : */}
                                <img
                                    src={process.env.REACT_APP_S3URL + basicInfo.profileImage}
                                    alt={basicInfo.name}
                                    className="img_HW"
                                />
                                {/* } */}
                                <div className=" aboutDealerText_20 cpm">{basicInfo.name}</div>
                                <div className="cpm">{basicInfo.designation}</div>
                                <div>at</div>
                                <div className=" turnWid2">{basicInfo.storeName}</div>
                            </div>
                        </div>
                    // </div>

                }

                <div>
                    <div className={pathname === parms || pathname === jobId ? 'w-100 text-dark' : "position-absolute w-100 top_0 text-white bgheader"}>
                        <div className="mx-2">
                            <Row className="mx-0  align-items-center ">
                                <Col className="text-start">
                                    <Link to="/" ><img src={pathname === parms || pathname === jobId ? "/assets/images/wallicon_logo.png" : "/assets/images/wallicon_white_logo.png"} alt="Wallicon" height={46} /></Link>
                                </Col>
                                {!localStorage.getItem("dealerId")
                                    ? "" :
                                    <Col className="text-center pf">
                                        <div>Authorised Dealer</div>
                                        <h4 className="mb-0">{localStorage.getItem("storeName")}</h4>
                                    </Col>
                                }
                                {
                                    !demo ? "" :
                                        <Col className="text-center pf">
                                            <h4 className="mb-0">YOUR COMPANY NAME</h4>
                                        </Col>
                                }

                                <Col >
                                    <div className="d-flex justify-content-end mb-1 cp">
                                        <div className="mouse" onClick={() => navigate("/checkout/cart")}>
                                            <img src={pathname === parms || pathname === jobId ? "/assets/icons/bag.svg" : "/assets/icons/bagWhite.svg"} alt="bg" height={38} className="mouse mt-3 me-4" />

                                            {cart.length === 0 ? "" : <>
                                                <img src={pathname === parms || pathname === jobId ? "/assets/icons/cartBlack.svg" : "/assets/icons/cartWhite.svg"} alt="cart" className="cartIcon" />
                                                <label className="cartLength">{cart.length}</label>
                                            </>
                                            }
                                        </div>
                                        {!localStorage.getItem("dealerId") && !demo ?
                                            <>
                                                <div className="text-center">
                                                    <div>FOR CUSTOMER</div>
                                                    <input
                                                        type="text"
                                                        placeholder="ENTER DEALER ID"
                                                        className="customerbtn"
                                                        value={dealerId !== null ? dealerId : ""}
                                                        onChange={(e) => setDealerId(e.target.value)}
                                                    />
                                                </div>
                                                <div className="ms-4 text-center">
                                                    <div>FOR DEALER</div>
                                                    <a target="_blank" rel="noreferrer" href="https://dealer.wallicon.in" className="regbtn" >REGISTER</a>
                                                </div>
                                            </>
                                            : ""}
                                    </div>
                                </Col>
                            </Row>

                        </div>
                        <HeaderMenu parms={parms} pathname={pathname} jobId={jobId} />
                        {pathname === '/' ? <HeaderProducts /> : ''}
                    </div>
                </div>

                {
                    showModel && <EnqulryModal close={setShowModel}/>
                }
            </div>

        </React.Fragment>
    )
}

export default Header

// --------------------------------------------Header Menu-------------------------------------
export const HeaderMenu = ({ pathname, parms, jobId }) => {
    const dealerId = localStorage.getItem("dealerId")
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [delaerShow, setDelaerShow] = useState(false);
    const selectModal = () => {
        setOpen(!open) // true/false toggle
    }

    const [data, setData] = useState([])

    const [filteredData, setFilteredData] = useState([]);
    const [wordEntered, setWordEntered] = useState("");

    useEffect(() => {
        if (wordEntered) {
            var myHeaders = new Headers();
            myHeaders.append("wu-platform", process.env.REACT_APP_USER_SECRET);
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                "keyword": wordEntered
            });

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            fetch(process.env.REACT_APP_URL + "customer/search", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "success") {
                        setData(result.data);
                    }
                })
                .catch(error => console.log('error', error));
        }
    }, [wordEntered]);

    const handleFilter = (event) => {
        const searchWord = event.target.value;
        setWordEntered(searchWord);
        if (data) {
            const newFilter = data.filter(item => item.itemNo ? item.itemNo.toLowerCase().includes(searchWord.toLowerCase()) :
                item.product_name && item.collection_name ? item.collection_name.toLowerCase().includes(searchWord.toLowerCase()) :
                    item.product_name.toLowerCase().includes(searchWord.toLowerCase())
            );

            if (searchWord === "") {
                setFilteredData([]);
            } else {
                setFilteredData(newFilter);
            }
        }
    };


    return (
        <React.Fragment>
            <DealerConnectModal
                show={delaerShow}
                setShow={setDelaerShow}
            />
            <CatalogsModal
                displayModal={open}
                closeModal={selectModal}
            />
            <div className={`border-bottom border-top border-1 py-1 ${pathname === parms || pathname === jobId ? "border-dark" : "border-white"}`}>
                <div className="mx-2 ">
                    <Row className="align-items-center mx-0">
                        <Col >
                            <h6 onClick={() => { setOpen(!open) }} className="mouse header_text mb-0">CATALOGS</h6>
                        </Col>
                        <Col >
                            <h6 className="mouse header_text mb-0">NEW LAUNCH</h6>
                        </Col>
                        <Col >
                            <h6 className="mouse header_text mb-0">OFFERS</h6>
                        </Col>
                        <Col >
                            <h6 className="mouse header_text mb-0">EXPERT</h6>
                        </Col>
                        <Col >
                            <h6 className="mouse header_text mb-0" onClick={() => { !dealerId ? setDelaerShow(true) : navigate("about") }}>ABOUT</h6>
                        </Col>
                        {/* <Col >
                            <h6 className="mouse header_text mb-0" onClick={() => navigate("order")}>ORDER</h6>
                        </Col> */}
                        <Col xl="2" lg="3" xs="4" className="align-items-center d-flex ps-0">
                            <h6 className="mouse header_text mb-0 me-5" onClick={() => navigate("order")}>ORDER</h6>
                            <Dropdown className='bg-transparent p-0'>
                                <Dropdown.Toggle id="dropdown-custom-components" className='bg-transparent p-0 border-0 w-100'>
                                    <img src="/assets/icons/search.svg" alt="search" className="mouse position-absolute search_icon" height="14" />
                                    <input type="search"
                                        name="search"
                                        placeholder="SEARCH"
                                        value={wordEntered}
                                        onChange={handleFilter}
                                        className="rounded-pill w-100 ps-4 pe-2 py-1 "
                                    />
                                </Dropdown.Toggle>

                                <Dropdown.Menu className='w-100 py-0'>
                                    <div className='search_suggestion'>
                                        {
                                            filteredData.length !== 0 ?
                                                filteredData.slice(0, 15).map((item, key) => {
                                                    return (
                                                        <div key={key}
                                                            onClick={() => {
                                                                if (item.itemNo) {
                                                                    navigate("/productdetails/" + item.title.replace(/[\s,-;]+/g, "-").toLowerCase() + "/" + item.itemNo)
                                                                } else if (item.product_name && !item.collection_name) {
                                                                    navigate("/" + item.product_name.toLowerCase().replace(/\s/g, '-'));
                                                                    localStorage.setItem("product", item.product_name);
                                                                    localStorage.setItem("tabSelection", "style");
                                                                }
                                                                else {
                                                                    navigate("/" + item.product_name.toLowerCase().replace(/\s/g, '-') + "/" + item.collection_name.toLowerCase().replace(/\s/g, '-'));
                                                                    localStorage.setItem("product", item.product_name);
                                                                    localStorage.setItem("tabSelection", "collection");
                                                                }
                                                            }}

                                                        >
                                                            <p className="border-bottom px-2 mb-1 pb-1">
                                                                {item.itemNo ? item.itemNo : item.collection_name ? item.collection_name : item.product_name}
                                                                <img src="/assets/icons/searchArrow.svg" alt="Search" className="float-end mt-2" />
                                                            </p>
                                                        </div>
                                                    );
                                                })
                                                : <h3 className="moreDataLoader cpm">No data found</h3>
                                        }
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Col>

                    </Row>

                    {/* {!open ? '' :
                        <div className="position-absolute cp bg-white zindex" onClick={() => { setOpen(!open) }} >
                            <CatalogsDropDown />
                        </div>
                    } */}
                    {/* {!open ? '' :
                        <div className="position-absolute cp bg-white zindex" onClick={() => { setOpen(!open) }} >
                            <CatalogsDropDown />
                        </div>
                    } */}

                </div>
            </div>
        </React.Fragment>
    )
}

// --------------------------------------------Header Products-------------------------------------

export const CatalogsModal = (props) => {
    const navigate = useNavigate();
    const { dealerId, styles, setStyles } = useAuth()
    const [products, setPrducts] = useState([]);

    useEffect(() => {
        var myHeaders = new Headers();
        myHeaders.append("wu-platform", process.env.REACT_APP_USER_SECRET);
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow'
        };

        fetch(process.env.REACT_APP_URL + "customer/styles", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === "success") {
                    setPrducts(result.products);
                    setStyles(result.styles);
                }
            })
            .catch(error => console.log('error', error));
    }, [setStyles]);

    // console.log(styles)
    return (
        <React.Fragment>
            <Modal
                show={props.displayModal}
                onHide={() => props.closeModal()}
                dialogClassName="modal-90w ps-0"
            >
                <Modal.Body>
                    <Row className="m-0 pe-2 row-cols-5 text-dark" >
                        {products.map((item, index) =>
                            < >
                                {index === 0 ?
                                    <>
                                        <Col className="p-0 text-dark">
                                            <img src={process.env.REACT_APP_S3URL + item.src} alt="col" className="w-100 h-100 cate_img obj_fit"
                                                onClick={() => {
                                                    navigate("/" + item.product_name.toLowerCase().replace(/\s/g, '-') + (dealerId && "?dealerId=" + dealerId));
                                                    props.closeModal();
                                                }}
                                            />
                                        </Col>
                                        <Col className="p-0 text-dark" >
                                            <div className="cate_sub_cate_pe pt-3">
                                                <h6 className="cpm">{item.product_name}</h6>
                                                {styles.map((obj, index1) => obj.product_name === item.product_name ?
                                                    <div key={index1} onClick={() => {
                                                        navigate("/" + obj.product_name.toLowerCase().replace(/\s/g, '-')
                                                            + "/" + obj.style_name.toLowerCase().replace(/\s/g, '-')
                                                            + "?sid=" + obj._id + (dealerId && "&dealerId=" + dealerId))
                                                        props.closeModal()
                                                    }} className="mb-1 mouse">
                                                        {obj.style_name}
                                                    </div>
                                                    : ""
                                                )}
                                            </div>
                                        </Col>
                                    </>
                                    : index === 1 ?
                                        <>
                                            <Col className="p-0 text-dark">
                                                <img src={process.env.REACT_APP_S3URL + item.src} alt="col" className="w-100 h-100 cate_img obj_fit"
                                                    onClick={() => {
                                                        navigate("/" + item.product_name.toLowerCase().replace(/\s/g, '-') + (dealerId && "?dealerId=" + dealerId));
                                                        props.closeModal();
                                                    }}
                                                />
                                            </Col>
                                            <Col className="p-0 text-dark" >
                                                <div className="cate_sub_cate_pe pt-3">
                                                    <h6 className="cpm">{item.product_name}</h6>
                                                    {styles.map(obj => obj.product_name === item.product_name ?
                                                        <div onClick={() => {
                                                            navigate("/" + obj.product_name.toLowerCase().replace(/\s/g, '-')
                                                                + "/" + obj.style_name.toLowerCase().replace(/\s/g, '-')
                                                                + "?sid=" + obj._id + (dealerId && "&dealerId=" + dealerId))
                                                            props.closeModal()
                                                        }} className="mb-1 mouse">
                                                            {obj.style_name}
                                                        </div>
                                                        : ""
                                                    )}
                                                </div>
                                            </Col>
                                        </>
                                        : index === 2 ?
                                            <>
                                                <Col className="p-0 text-dark">
                                                    <img src={process.env.REACT_APP_S3URL + item.src} alt="col" className="w-100 h-100 cate_img obj_fit"
                                                        onClick={() => {
                                                            navigate("/" + item.product_name.toLowerCase().replace(/\s/g, '-') + (dealerId && "?dealerId=" + dealerId));
                                                            props.closeModal();
                                                        }}
                                                    />
                                                </Col>
                                                <Col className="p-0 text-dark" >
                                                    <div className="cate_sub_cate_pe pt-3">
                                                        <h6 className="cpm">{item.product_name}</h6>
                                                        {styles.map(obj => obj.product_name === item.product_name ?
                                                            <div onClick={() => {
                                                                navigate("/" + obj.product_name.toLowerCase().replace(/\s/g, '-')
                                                                    + "/" + obj.style_name.toLowerCase().replace(/\s/g, '-')
                                                                    + "?sid=" + obj._id + (dealerId && "&dealerId=" + dealerId))
                                                                props.closeModal()
                                                            }} className="mb-1 mouse">
                                                                {obj.style_name}
                                                            </div>
                                                            : ""
                                                        )}
                                                    </div>
                                                </Col>
                                            </>
                                            : index === 3 ?
                                                <>
                                                    <Col className="p-0 text-dark">
                                                        <img src={process.env.REACT_APP_S3URL + item.src} alt="col" className="w-100 h-100 cate_img obj_fit"
                                                            onClick={() => {
                                                                navigate("/" + item.product_name.toLowerCase().replace(/\s/g, '-') + (dealerId && "?dealerId=" + dealerId));
                                                                props.closeModal();
                                                            }}
                                                        />
                                                    </Col>
                                                    <Col className="p-0 text-dark" >
                                                        <div className="cate_sub_cate_pe pt-3">
                                                            <h6 className="cpm">{item.product_name}</h6>
                                                            {styles.map(obj => obj.product_name === item.product_name ?
                                                                <div onClick={() => {
                                                                    navigate("/" + obj.product_name.toLowerCase().replace(/\s/g, '-')
                                                                        + "/" + obj.style_name.toLowerCase().replace(/\s/g, '-')
                                                                        + "?sid=" + obj._id + (dealerId && "&dealerId=" + dealerId))
                                                                    props.closeModal()
                                                                }} className="mb-1 mouse">
                                                                    {obj.style_name}
                                                                </div>
                                                                : ""
                                                            )}
                                                        </div>
                                                    </Col>
                                                </>
                                                : index === 4 ?
                                                    <>
                                                        <Col className="p-0 text-dark">
                                                            <img src={process.env.REACT_APP_S3URL + item.src} alt="col" className="w-100 h-100 cate_img obj_fit"
                                                                onClick={() => {
                                                                    navigate("/" + item.product_name.toLowerCase().replace(/\s/g, '-') + (dealerId && "?dealerId=" + dealerId));
                                                                    props.closeModal();
                                                                }}
                                                            />
                                                        </Col>
                                                        <Col className="p-0 text-dark" >
                                                            <div className="cate_sub_cate_pe pt-3">
                                                                <h6 className="cpm">{item.product_name}</h6>
                                                                {styles.map(obj => obj.product_name === item.product_name ?
                                                                    <div onClick={() => {
                                                                        navigate("/" + obj.product_name.toLowerCase().replace(/\s/g, '-')
                                                                            + "/" + obj.style_name.toLowerCase().replace(/\s/g, '-')
                                                                            + "?sid=" + obj._id + (dealerId && "&dealerId=" + dealerId))
                                                                        props.closeModal()
                                                                    }} className="mb-1 mouse">
                                                                        {obj.style_name}
                                                                    </div>
                                                                    : ""
                                                                )}
                                                            </div>
                                                        </Col>
                                                    </>
                                                    : index === 5 ?
                                                        <>
                                                            <Col className="p-0 text-dark">
                                                                <img src={process.env.REACT_APP_S3URL + item.src} alt="col" className="w-100 h-100 cate_img obj_fit"
                                                                    onClick={() => {
                                                                        navigate("/" + item.product_name.toLowerCase().replace(/\s/g, '-') + (dealerId && "?dealerId=" + dealerId));
                                                                        props.closeModal();
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col className="p-0 text-dark" >
                                                                <div className="cate_sub_cate_pe pt-3">
                                                                    <h6 className="cpm">{item.product_name}</h6>
                                                                    {styles.map(obj => obj.product_name === item.product_name ?
                                                                        <div onClick={() => {
                                                                            navigate("/" + obj.product_name.toLowerCase().replace(/\s/g, '-')
                                                                                + "/" + obj.style_name.toLowerCase().replace(/\s/g, '-')
                                                                                + "?sid=" + obj._id + (dealerId && "&dealerId=" + dealerId))
                                                                            props.closeModal()
                                                                        }} className="mb-1 mouse">
                                                                            {obj.style_name}
                                                                        </div>
                                                                        : ""
                                                                    )}
                                                                </div>
                                                            </Col>
                                                        </>
                                                        : index === 6 ?
                                                            <>
                                                                <Col className="p-0 text-dark">
                                                                    <img src={process.env.REACT_APP_S3URL + item.src} alt="col" className="w-100 h-100 cate_img obj_fit"
                                                                        onClick={() => {
                                                                            navigate("/" + item.product_name.toLowerCase().replace(/\s/g, '-') + (dealerId && "?dealerId=" + dealerId));
                                                                            props.closeModal();
                                                                        }}
                                                                    />
                                                                </Col>
                                                                <Col className="p-0 text-dark" >
                                                                    <div className="cate_sub_cate_pe pt-3">
                                                                        <h6 className="cpm">{item.product_name}</h6>
                                                                        {styles.map(obj => obj.product_name === item.product_name ?
                                                                            <div onClick={() => {
                                                                                navigate("/" + obj.product_name.toLowerCase().replace(/\s/g, '-')
                                                                                    + "/" + obj.style_name.toLowerCase().replace(/\s/g, '-')
                                                                                    + "?sid=" + obj._id + (dealerId && "&dealerId=" + dealerId))
                                                                                props.closeModal()
                                                                            }} className="mb-1 mouse">
                                                                                {obj.style_name}
                                                                            </div>
                                                                            : ""
                                                                        )}
                                                                    </div>
                                                                </Col>
                                                            </>
                                                            : ""}
                            </>
                        )}
                    </Row>


                </Modal.Body>
            </Modal>
            {/* <div
                className="custom_modal "
                onClick={closeModal}
                style={divStyle} 
                >
                <div className="position-absolute cp bg-white zindex  mt-2">

                    <Row className="m-0 pe-2 row-cols-5 text-dark" >
                        {products.map((item, index) =>
                            < >
                                {index === 0 ?
                                    <>
                                        <Col className="p-0 text-dark">
                                            <img src={process.env.REACT_APP_URL + item.src} alt="col" className="w-100 h-100 cate_img obj_fit"
                                                onClick={() => {
                                                    navigate("/" + item.product_name.toLowerCase().replace(/\s/g, '-'));
                                                    localStorage.setItem("product", item.product_name);
                                                    localStorage.setItem("tabSelection", "style");
                                                }}
                                            />
                                        </Col>
                                        <Col className="p-0 text-dark" >
                                            <div className="cate_sub_cate_pe pt-3">
                                                <h6 className="cpm">{item.product_name}</h6>
                                                {styles.map((obj, index1) => obj.product_name === item.product_name ?
                                                    <div key={index1} onClick={() => {
                                                        navigate("/" + obj.product_name.toLowerCase().replace(/\s/g, '-') + "/" + obj.style_name.toLowerCase().replace(/\s/g, '-'));
                                                        localStorage.setItem("product", obj.product_name);
                                                        localStorage.setItem("tabSelection", "type");
                                                    }} className="mb-1 mouse">
                                                        {obj.style_name}
                                                    </div>
                                                    : ""
                                                )}
                                            </div>
                                        </Col>
                                    </>
                                    : index === 1 ?
                                        <>
                                            <Col className="p-0 text-dark">
                                                <img src={process.env.REACT_APP_URL + item.src} alt="col" className="w-100 h-100 cate_img obj_fit"
                                                    onClick={() => {
                                                        navigate("/" + item.product_name.toLowerCase().replace(/\s/g, '-'));
                                                        localStorage.setItem("product", item.product_name);
                                                        localStorage.setItem("tabSelection", "style");
                                                    }}
                                                />
                                            </Col>
                                            <Col className="p-0 text-dark" >
                                                <div className="cate_sub_cate_pe pt-3">
                                                    <h6 className="cpm">{item.product_name}</h6>
                                                    {styles.map(obj => obj.product_name === item.product_name ?
                                                        <div onClick={() => {
                                                            navigate("/" + obj.product_name.toLowerCase().replace(/\s/g, '-') + "/" + obj.style_name.toLowerCase().replace(/\s/g, '-'));
                                                            localStorage.setItem("product", obj.product_name);
                                                            localStorage.setItem("tabSelection", "type");
                                                        }} className="mb-1 mouse">
                                                            {obj.style_name}
                                                        </div>
                                                        : ""
                                                    )}
                                                </div>
                                            </Col>
                                        </>
                                        : index === 2 ?
                                            <>
                                                <Col className="p-0 text-dark">
                                                    <img src={process.env.REACT_APP_URL + item.src} alt="col" className="w-100 h-100 cate_img obj_fit"
                                                        onClick={() => {
                                                            navigate("/" + item.product_name.toLowerCase().replace(/\s/g, '-'));
                                                            localStorage.setItem("product", item.product_name);
                                                            localStorage.setItem("tabSelection", "style");
                                                        }}
                                                    />
                                                </Col>
                                                <Col className="p-0 text-dark" >
                                                    <div className="cate_sub_cate_pe pt-3">
                                                        <h6 className="cpm">{item.product_name}</h6>
                                                        {styles.map(obj => obj.product_name === item.product_name ?
                                                            <div onClick={() => {
                                                                navigate("/" + obj.product_name.toLowerCase().replace(/\s/g, '-') + "/" + obj.style_name.toLowerCase().replace(/\s/g, '-'));
                                                                localStorage.setItem("product", obj.product_name);
                                                                localStorage.setItem("tabSelection", "type");
                                                            }} className="mb-1 mouse">
                                                                {obj.style_name}
                                                            </div>
                                                            : ""
                                                        )}
                                                    </div>
                                                </Col>
                                            </>
                                            : index === 3 ?
                                                <>
                                                    <Col className="p-0 text-dark">
                                                        <img src={process.env.REACT_APP_URL + item.src} alt="col" className="w-100 h-100 cate_img obj_fit"
                                                            onClick={() => {
                                                                navigate("/" + item.product_name.toLowerCase().replace(/\s/g, '-'));
                                                                localStorage.setItem("product", item.product_name);
                                                                localStorage.setItem("tabSelection", "style");
                                                            }}
                                                        />
                                                    </Col>
                                                    <Col className="p-0 text-dark" >
                                                        <div className="cate_sub_cate_pe pt-3">
                                                            <h6 className="cpm">{item.product_name}</h6>
                                                            {styles.map(obj => obj.product_name === item.product_name ?
                                                                <div onClick={() => {
                                                                    navigate("/" + obj.product_name.toLowerCase().replace(/\s/g, '-') + "/" + obj.style_name.toLowerCase().replace(/\s/g, '-'));
                                                                    localStorage.setItem("product", obj.product_name);
                                                                    localStorage.setItem("tabSelection", "type");
                                                                }} className="mb-1 mouse">
                                                                    {obj.style_name}
                                                                </div>
                                                                : ""
                                                            )}
                                                        </div>
                                                    </Col>
                                                </>
                                                : index === 4 ?
                                                    <>
                                                        <Col className="p-0 text-dark">
                                                            <img src={process.env.REACT_APP_URL + item.src} alt="col" className="w-100 h-100 cate_img obj_fit"
                                                                onClick={() => {
                                                                    navigate("/" + item.product_name.toLowerCase().replace(/\s/g, '-'));
                                                                    localStorage.setItem("product", item.product_name);
                                                                    localStorage.setItem("tabSelection", "style");
                                                                }}
                                                            />
                                                        </Col>
                                                        <Col className="p-0 text-dark" >
                                                            <div className="cate_sub_cate_pe pt-3">
                                                                <h6 className="cpm">{item.product_name}</h6>
                                                                {styles.map(obj => obj.product_name === item.product_name ?
                                                                    <div onClick={() => {
                                                                        navigate("/" + obj.product_name.toLowerCase().replace(/\s/g, '-') + "/" + obj.style_name.toLowerCase().replace(/\s/g, '-'));
                                                                        localStorage.setItem("product", obj.product_name);
                                                                        localStorage.setItem("tabSelection", "type");
                                                                    }} className="mb-1 mouse">
                                                                        {obj.style_name}
                                                                    </div>
                                                                    : ""
                                                                )}
                                                            </div>
                                                        </Col>
                                                    </>
                                                    : index === 5 ?
                                                        <>
                                                            <Col className="p-0 text-dark">
                                                                <img src={process.env.REACT_APP_URL + item.src} alt="col" className="w-100 h-100 cate_img obj_fit"
                                                                    onClick={() => {
                                                                        navigate("/" + item.product_name.toLowerCase().replace(/\s/g, '-'));
                                                                        localStorage.setItem("product", item.product_name);
                                                                        localStorage.setItem("tabSelection", "style");
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col className="p-0 text-dark" >
                                                                <div className="cate_sub_cate_pe pt-3">
                                                                    <h6 className="cpm">{item.product_name}</h6>
                                                                    {styles.map(obj => obj.product_name === item.product_name ?
                                                                        <div onClick={() => {
                                                                            navigate("/" + obj.product_name.toLowerCase().replace(/\s/g, '-') + "/" + obj.style_name.toLowerCase().replace(/\s/g, '-'));
                                                                            localStorage.setItem("product", obj.product_name);
                                                                            localStorage.setItem("tabSelection", "type");
                                                                        }} className="mb-1 mouse">
                                                                            {obj.style_name}
                                                                        </div>
                                                                        : ""
                                                                    )}
                                                                </div>
                                                            </Col>
                                                        </>
                                                        : index === 6 ?
                                                            <>
                                                                <Col className="p-0 text-dark">
                                                                    <img src={process.env.REACT_APP_URL + item.src} alt="col" className="w-100 h-100 cate_img obj_fit"
                                                                        onClick={() => {
                                                                            navigate("/" + item.product_name.toLowerCase().replace(/\s/g, '-'));
                                                                            localStorage.setItem("product", item.product_name);
                                                                            localStorage.setItem("tabSelection", "style");
                                                                        }}
                                                                    />
                                                                </Col>
                                                                <Col className="p-0 text-dark" >
                                                                    <div className="cate_sub_cate_pe pt-3">
                                                                        <h6 className="cpm">{item.product_name}</h6>
                                                                        {styles.map(obj => obj.product_name === item.product_name ?
                                                                            <div onClick={() => {
                                                                                navigate("/" + obj.product_name.toLowerCase().replace(/\s/g, '-') + "/" + obj.style_name.toLowerCase().replace(/\s/g, '-'));
                                                                                localStorage.setItem("product", obj.product_name);
                                                                                localStorage.setItem("tabSelection", "type");
                                                                            }} className="mb-1 mouse">
                                                                                {obj.style_name}
                                                                            </div>
                                                                            : ""
                                                                        )}
                                                                    </div>
                                                                </Col>
                                                            </>
                                                            // : index === 7 ?
                                                            // <>
                                                            //     <Col className="p-0 text-dark">
                                                            //         <img src={item.src} alt="col" className="w-100 h-100 cate_img obj_fit" />
                                                            //     </Col>
                                                            //     <Col className="p-0 text-dark" >
                                                            //         <div className="cate_sub_cate_pe pt-3">
                                                            //             <h6 className="cpm">{item.product_name}</h6>
                                                            //             {styles.map(obj => obj.product_name === item.product_name ?
                                                            //                 <div className="mb-1">
                                                            //                     <Link to="" >{obj.style_name}</Link>
                                                            //                 </div>
                                                            //                 : ""
                                                            //             )}
                                                            //         </div>
                                                            //     </Col>
                                                            // </>
                                                            : ""}
                            </>
                        )} */}

            {/* {data.map((item, index) =>
                            <Col className="p-0" key={index}>
                                {item.src ? <img src={item.src} alt="col" className="w-100 h-100 cate_img obj_fit" /> :
                                    <div className="cate_sub_cate_pe pt-3">
                                        <h6 className="cpm">{item.item.p_name}</h6>
                                        {item.item.sub_p_name.map((item, index) =>
                                            <div key={index} className="mb-1">
                                                <Link to="" >{item.pname}</Link>
                                            </div>
                                        )}
                                    </div>
                                }
                            </Col>
                        )} */}
            {/* </Row> */}
            {/* // )} */}
            {/* </div> */}
            {/* </div> */}


        </React.Fragment>
    )
}
export const CatalogsDropDown = () => {
    const data = [
        {
            src: 'https://res.cloudinary.com/wallicon21/image/upload/v1629883013/react/hotitems/wallpaper2_y42utb.jpg'
        },
        {
            item: {
                p_name: 'WALLPAPERS',
                sub_p_name: [
                    { pname: 'Bedrooms' },
                    { pname: 'Drawing Room' },
                    { pname: 'Living Room' },
                    { pname: 'Kids Room' },
                    { pname: 'Hotel' },
                    { pname: 'For teenagers' },
                    { pname: 'Office' },
                ]
            }
        },
        {
            src: 'https://res.cloudinary.com/wallicon21/image/upload/v1629883013/react/hotitems/wallpaper2_y42utb.jpg'
        },
        {
            item: {
                p_name: 'WALLPAPERS',
                sub_p_name: [
                    { pname: 'Bedrooms' },
                    { pname: 'Drawing Room' },
                    { pname: 'Living Room' },
                    { pname: 'Kids Room' },
                    { pname: 'Hotel' },
                    { pname: 'For teenagers' },
                    { pname: 'Office' },
                ]
            }
        },
        {
            src: 'https://res.cloudinary.com/wallicon21/image/upload/v1629883013/react/hotitems/wallpaper2_y42utb.jpg'
        },
        {
            item: {
                p_name: 'WALLPAPERS',
                sub_p_name: [
                    { pname: 'Bedrooms' },
                    { pname: 'Drawing Room' },
                    { pname: 'Living Room' },
                    { pname: 'Kids Room' },
                    { pname: 'Hotel' },
                    { pname: 'For teenagers' },
                    { pname: 'Office' },
                ]
            }
        },
        {
            src: 'https://res.cloudinary.com/wallicon21/image/upload/v1629883013/react/hotitems/wallpaper2_y42utb.jpg'
        },
        {
            item: {
                p_name: 'WALLPAPERS',
                sub_p_name: [
                    { pname: 'Bedrooms' },
                    { pname: 'Drawing Room' },
                    { pname: 'Living Room' },
                    { pname: 'Kids Room' },
                    { pname: 'Hotel' },
                    { pname: 'For teenagers' },
                    { pname: 'Office' },
                ]
            }
        },
        {
            src: 'https://res.cloudinary.com/wallicon21/image/upload/v1629883013/react/hotitems/wallpaper2_y42utb.jpg'
        },
        {
            item: {
                p_name: 'WALLPAPERS',
                sub_p_name: [
                    { pname: 'Bedrooms' },
                    { pname: 'Drawing Room' },
                    { pname: 'Living Room' },
                    { pname: 'Kids Room' },
                    { pname: 'Hotel' },
                    { pname: 'For teenagers' },
                    { pname: 'Office' },
                ]
            }
        },
        {
            src: 'https://res.cloudinary.com/wallicon21/image/upload/v1629883013/react/hotitems/wallpaper2_y42utb.jpg'
        },
        {
            item: {
                p_name: 'WALLPAPERS',
                sub_p_name: [
                    { pname: 'Bedrooms' },
                    { pname: 'Drawing Room' },
                    { pname: 'Living Room' },
                    { pname: 'Kids Room' },
                    { pname: 'Hotel' },
                    { pname: 'For teenagers' },
                    { pname: 'Office' },
                ]
            }
        },
        {
            src: 'https://res.cloudinary.com/wallicon21/image/upload/v1629883013/react/hotitems/wallpaper2_y42utb.jpg'
        },
        {
            item: {
                p_name: 'WALLPAPERS',
                sub_p_name: [
                    { pname: 'Bedrooms' },
                    { pname: 'Drawing Room' },
                    { pname: 'Living Room' },
                    { pname: 'Kids Room' },
                    { pname: 'Hotel' },
                    { pname: 'For teenagers' },
                    { pname: 'Office' },
                ]
            }
        },
        {
            src: 'https://res.cloudinary.com/wallicon21/image/upload/v1629883013/react/hotitems/wallpaper2_y42utb.jpg'
        },

    ]

    return (
        <React.Fragment>
            <Row className="m-0 pe-2 row-cols-5">
                {data.map((item, index) =>
                    <Col className="p-0" key={index}>
                        {item.src ? <img src={item.src} alt="col" className="w-100 h-100 cate_img obj_fit" /> :
                            <div className="cate_sub_cate_pe pt-3">
                                <h6 className="cpm">{item.item.p_name}</h6>
                                {item.item.sub_p_name.map((item, index) =>
                                    <div key={index} className="mb-1">
                                        <Link to="" >{item.pname}</Link>
                                    </div>
                                )}
                            </div>
                        }
                    </Col>
                )}
            </Row>
        </React.Fragment>
    )
}

// --------------------------------------------Header Products-------------------------------------
export const HeaderProducts = () => {
    const navigate = useNavigate();
    const { products } = useAuth()

    return (
        <React.Fragment>
            <div className="pt-1 mx-2">
                <Row className="align-items-center mx-0">
                    {products.map((item, index) =>
                        <Col key={index}
                            onClick={() => {
                                localStorage.setItem("product", item.product_name);
                                navigate("/" + item.product_name.toLowerCase().replace(/\s/g, "-"))
                            }}
                        >
                            <h6 className="mouse header_text">{item.product_name}</h6>
                        </Col>
                    )}
                    {/* <Col onClick={() => { localStorage.setItem("product", "wallpapers"); navigate("/wallpapers") }}>
                        <h6 className="mouse header_text">WALLPAPERS</h6>
                    </Col>
                    <Col onClick={() => { localStorage.setItem("product", "pvc-panel"); navigate("/pvc-panel") }}>
                        <h6 className="mouse header_text">PVC PANELS</h6>
                    </Col>
                    <Col onClick={() => { localStorage.setItem("product", "flooring"); navigate("/flooring") }}>
                        <h6 className="mouse header_text">FLOORING</h6>
                    </Col>
                    <Col onClick={() => { localStorage.setItem("product", "ceiling"); navigate("/ceiling") }}>
                        <h6 className="mouse header_text">CEILING</h6>
                    </Col>
                    <Col onClick={() => { localStorage.setItem("product", "grass"); navigate("/grass") }}>
                        <h6 className="mouse header_text">GRASS</h6>
                    </Col>
                    <Col onClick={() => { localStorage.setItem("product", "blinds"); navigate("/blinds") }}>
                        <h6 className="mouse header_text">BLINDS</h6>
                    </Col>
                    <Col onClick={() => { localStorage.setItem("product", "vertical-garden"); navigate("/vertical-garden") }}>
                        <h6 className="mouse header_text">VERTICAL GARDEN</h6>
                    </Col> */}
                </Row>
            </div>
        </React.Fragment>
    )
}
